// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import { AppHeader } from "imagus-components";
import AdminQuotes from "../containers/quotes/AdminQuotes";
import Navbar from "../containers/Navbar";

class Projects extends Component<*> {

  render(): * {
    return (
      <UserAuth principal='imagus_admin' unAuthChildren={<RedirectoLogin />} >
        <div className="app-main">
          <AppHeader
            title="Site Administration"
            IconName="SettingsApplications"
          />
          <Navbar router={this.props.router} />
          <AdminQuotes />
        </div>
      </UserAuth>
    );
  }
}

export default Projects;
